// Cookie keys
const edCookieBannerShowWindowKey = 'ed-cookiebanner-show-window';
const edCookieBannerConsentFunctionalKey = 'ed-cookiebanner-consent-functional';
const edCookieBannerConsentPreferentialKey = 'ed-cookiebanner-consent-preferential';
const edCookieBannerConsentAnalyticKey = 'ed-cookiebanner-consent-analytic';
const edCookieBannerConsentMarketingKey = 'ed-cookiebanner-consent-marketing';


// Texts
const contentText  = `
    K personalizaci obsahu a reklam, poskytování funkcí sociálních médií a analýze naší návštěvnosti využíváme soubory cookie. Informace o tom, jak náš web používáte, sdílíme se svými partnery pro sociální média, inzerci a analýzy. 
    Partneři tyto údaje mohou zkombinovat s dalšími informacemi, které jste jim poskytli nebo které získali v důsledku toho, že používáte jejich služby.
`;
const functionalText = `
    Nutné cookies pomáhají, aby byla webová stránka použitelná tak, že umožní základní funkce jako navigace stránky a přístup k zabezpečeným sekcím webové stránky. Webová stránka nemůže správně fungovat bez těchto cookies.
`;
const preferentialText = `
    Preferenční cookies umožňují, aby si webová stránka zapamatovala informace, které mění, jak se webová stránka chová nebo jak vypadá. Je to například preferovaný jazyk nebo region, kde se nacházíte.
`;
const analyticText = `
    Statistické cookies pomáhají majitelům webových stránek, aby porozuměli, jak návštěvníci používají webové stránky. Anonymně sbírají a sdělují informace.
`;
const mareketingText = `
    Marketingové cookies jsou používány pro sledování návštěvníků na webových stránkách. Záměrem je zobrazit reklamu, která je relevantní a zajímavá pro jednotlivého uživatele a tímto hodnotnější pro vydavatele a inzerenty třetích stran.
`;

window.onload = function() {
    // Create Cookie Banner
    createEDCookieBanner();
    // Create Cookie manage consent
    createEDCookieMangeConsent();
    // Init events
    initEDCookieEvents();
};

function createEDCookieBanner() {
    // Wrap
    const edCookieWindow = document.createElement('div');
    edCookieWindow.id = 'ed-cookiebanner-window';
    edCookieWindow.className = 'ed-cookiebanner-hidden';

    // Header
    const edCookieHeader = document.createElement('div');
    edCookieHeader.className = 'ed-cookiebanner-window-header';
    edCookieHeader.textContent = 'Spravovat souhlas s cookies';
    edCookieWindow.append(edCookieHeader);

    // Content
    const edCookieContent = document.createElement('div');
    edCookieContent.className = 'ed-cookiebanner-window-content';
    edCookieContent.textContent = contentText;
    edCookieWindow.append(edCookieContent);

    // Preferences
    const edCookiePreferencesWrap = document.createElement('div');
    edCookiePreferencesWrap.className = 'ed-cookiebanner-preferences-wrap ed-cookiebanner-hidden';
    // Functional
    const edCookieFunctionalAccordion = document.createElement('div');
    edCookieFunctionalAccordion.className = 'ed-cookiebanner-accordion';
    const edCookieFunctionalAccordionButton = document.createElement('button');
    edCookieFunctionalAccordionButton.className = 'ed-cookiebanner-accordion-header ed-cookiebanner-accordion-close';
    edCookieFunctionalAccordionButton.textContent = 'Funkční cookies';
    const edCookieFunctionalAccordionLabel = document.createElement('label');
    edCookieFunctionalAccordionLabel.className = 'ed-cookiebanner-accordion-switch';
    const edCookieFunctionalAccordionInput = document.createElement('input');
    edCookieFunctionalAccordionInput.setAttribute('type', 'checkbox');
    edCookieFunctionalAccordionInput.setAttribute('disabled', true);
    edCookieFunctionalAccordionInput.checked = true;
    edCookieFunctionalAccordionInput.id = 'ed-cookiebanner-functional-checkbox';
    edCookieFunctionalAccordionInput.className = 'ed-cookiebanner-switch-checkbox';
    edCookieFunctionalAccordionLabel.append(edCookieFunctionalAccordionInput);
    const edCookieFunctionalAccordionSpan = document.createElement('span');
    edCookieFunctionalAccordionSpan.className = 'ed-cookiebanner-switch-slider ed-cookiebanner-switch-slider-disabled';
    edCookieFunctionalAccordionLabel.append(edCookieFunctionalAccordionSpan);
    edCookieFunctionalAccordionButton.append(edCookieFunctionalAccordionLabel);
    edCookieFunctionalAccordion.append(edCookieFunctionalAccordionButton);
    const edCookieFunctionalAccordionText = document.createElement('div');
    edCookieFunctionalAccordionText.className = 'ed-cookiebanner-switch-panel ed-cookiebanner-switch-panel-hidden';
    edCookieFunctionalAccordionText.textContent = functionalText;
    edCookieFunctionalAccordion.append(edCookieFunctionalAccordionText);
    edCookiePreferencesWrap.append(edCookieFunctionalAccordion);
    // Preferential
    const edCookiePreferentialAccordion = document.createElement('div');
    edCookiePreferentialAccordion.className = 'ed-cookiebanner-accordion';
    const edCookiePreferentialAccordionButton = document.createElement('button');
    edCookiePreferentialAccordionButton.className = 'ed-cookiebanner-accordion-header ed-cookiebanner-accordion-close';
    edCookiePreferentialAccordionButton.textContent = 'Preferenční cookies';
    const edCookiePreferentialAccordionLabel = document.createElement('label');
    edCookiePreferentialAccordionLabel.className = 'ed-cookiebanner-accordion-switch';
    const edCookiePreferentialAccordionInput = document.createElement('input');
    edCookiePreferentialAccordionInput.setAttribute('type', 'checkbox');
    edCookiePreferentialAccordionInput.checked = edGetCookie(edCookieBannerConsentPreferentialKey, '0') === '1';
    edCookiePreferentialAccordionInput.id = 'ed-cookiebanner-preferential-checkbox';
    edCookiePreferentialAccordionInput.className = 'ed-cookiebanner-switch-checkbox';
    edCookiePreferentialAccordionLabel.append(edCookiePreferentialAccordionInput);
    const edCookiePreferentialAccordionSpan = document.createElement('span');
    edCookiePreferentialAccordionSpan.className = 'ed-cookiebanner-switch-slider';
    edCookiePreferentialAccordionLabel.append(edCookiePreferentialAccordionSpan);
    edCookiePreferentialAccordionButton.append(edCookiePreferentialAccordionLabel);
    edCookiePreferentialAccordion.append(edCookiePreferentialAccordionButton);
    const edCookiePreferentialAccordionText = document.createElement('div');
    edCookiePreferentialAccordionText.className = 'ed-cookiebanner-switch-panel ed-cookiebanner-switch-panel-hidden';
    edCookiePreferentialAccordionText.textContent = preferentialText;
    edCookiePreferentialAccordion.append(edCookiePreferentialAccordionText);
    edCookiePreferencesWrap.append(edCookiePreferentialAccordion);
    // Analytic
    const edCookieAnalyticAccordion = document.createElement('div');
    edCookieAnalyticAccordion.className = 'ed-cookiebanner-accordion';
    const edCookieAnalyticAccordionButton = document.createElement('button');
    edCookieAnalyticAccordionButton.className = 'ed-cookiebanner-accordion-header ed-cookiebanner-accordion-close';
    edCookieAnalyticAccordionButton.textContent = 'Analytické cookies';
    const edCookieAnalyticAccordionLabel = document.createElement('label');
    edCookieAnalyticAccordionLabel.className = 'ed-cookiebanner-accordion-switch';
    const edCookieAnalyticAccordionInput = document.createElement('input');
    edCookieAnalyticAccordionInput.setAttribute('type', 'checkbox');
    edCookieAnalyticAccordionInput.checked = edGetCookie(edCookieBannerConsentAnalyticKey, '0') === '1';
    edCookieAnalyticAccordionInput.id = 'ed-cookiebanner-analytic-checkbox';
    edCookieAnalyticAccordionInput.className = 'ed-cookiebanner-switch-checkbox';
    edCookieAnalyticAccordionLabel.append(edCookieAnalyticAccordionInput);
    const edCookieAnalyticAccordionSpan = document.createElement('span');
    edCookieAnalyticAccordionSpan.className = 'ed-cookiebanner-switch-slider';
    edCookieAnalyticAccordionLabel.append(edCookieAnalyticAccordionSpan);
    edCookieAnalyticAccordionButton.append(edCookieAnalyticAccordionLabel);
    edCookieAnalyticAccordion.append(edCookieAnalyticAccordionButton);
    const edCookieAnalyticAccordionText = document.createElement('div');
    edCookieAnalyticAccordionText.className = 'ed-cookiebanner-switch-panel ed-cookiebanner-switch-panel-hidden';
    edCookieAnalyticAccordionText.textContent = analyticText;
    edCookieAnalyticAccordion.append(edCookieAnalyticAccordionText);
    edCookiePreferencesWrap.append(edCookieAnalyticAccordion);
    // Marketing
    const edCookieMarketingAccordion = document.createElement('div');
    edCookieMarketingAccordion.className = 'ed-cookiebanner-accordion';
    const edCookieMarketingAccordionButton = document.createElement('button');
    edCookieMarketingAccordionButton.className = 'ed-cookiebanner-accordion-header ed-cookiebanner-accordion-close';
    edCookieMarketingAccordionButton.textContent = 'Marketingové cookies';
    const edCookieMarketingAccordionLabel = document.createElement('label');
    edCookieMarketingAccordionLabel.className = 'ed-cookiebanner-accordion-switch';
    const edCookieMarketingAccordionInput = document.createElement('input');
    edCookieMarketingAccordionInput.setAttribute('type', 'checkbox');
    edCookieMarketingAccordionInput.checked = edGetCookie(edCookieBannerConsentMarketingKey, '0') === '1';
    edCookieMarketingAccordionInput.id = 'ed-cookiebanner-marketing-checkbox';
    edCookieMarketingAccordionInput.className = 'ed-cookiebanner-switch-checkbox';
    edCookieMarketingAccordionLabel.append(edCookieMarketingAccordionInput);
    const edCookieMarketingAccordionSpan = document.createElement('span');
    edCookieMarketingAccordionSpan.className = 'ed-cookiebanner-switch-slider';
    edCookieMarketingAccordionLabel.append(edCookieMarketingAccordionSpan);
    edCookieMarketingAccordionButton.append(edCookieMarketingAccordionLabel);
    edCookieMarketingAccordion.append(edCookieMarketingAccordionButton);
    const edCookieMarketingAccordionText = document.createElement('div');
    edCookieMarketingAccordionText.className = 'ed-cookiebanner-switch-panel ed-cookiebanner-switch-panel-hidden';
    edCookieMarketingAccordionText.textContent = mareketingText;
    edCookieMarketingAccordion.append(edCookieMarketingAccordionText);
    edCookiePreferencesWrap.append(edCookieMarketingAccordion);


    edCookieWindow.append(edCookiePreferencesWrap);

    // Buttons
    const edCookieButtonsWrap = document.createElement('div');
    edCookieButtonsWrap.className = 'ed-cookiebanner-buttons-wrap';
    // Save all
    const edCookieButtonSaveAll = document.createElement('button');
    edCookieButtonSaveAll.id = 'ed-cookiebanner-save-all-button';
    edCookieButtonSaveAll.className = 'ed-cookiebanner-button ed-cookiebanner-button-active';
    edCookieButtonSaveAll.textContent = 'Přijmout vše';
    edCookieButtonsWrap.append(edCookieButtonSaveAll);
    // Reject
    const edCookieButtonReject = document.createElement('button');
    edCookieButtonReject.id = 'ed-cookiebanner-reject-button';
    edCookieButtonReject.className = 'ed-cookiebanner-button ed-cookiebanner-button-inactive';
    edCookieButtonReject.textContent = 'Odmítnout';
    edCookieButtonsWrap.append(edCookieButtonReject);
    // Show preferences
    const edCookieButtonShowPreferences = document.createElement('button');
    edCookieButtonShowPreferences.id = 'ed-cookiebanner-show-preferences-button';
    edCookieButtonShowPreferences.className = 'ed-cookiebanner-button ed-cookiebanner-button-inactive';
    edCookieButtonShowPreferences.textContent = 'Zobrazit předvolby';
    edCookieButtonsWrap.append(edCookieButtonShowPreferences);
    // Save preferences
    const edCookieButtonSavePreferences = document.createElement('button');
    edCookieButtonSavePreferences.id = 'ed-cookiebanner-save-preferences-button';
    edCookieButtonSavePreferences.className = 'ed-cookiebanner-button ed-cookiebanner-button-inactive ed-cookiebanner-hidden';
    edCookieButtonSavePreferences.textContent = 'Uložit předvolby';
    edCookieButtonsWrap.append(edCookieButtonSavePreferences);

    edCookieWindow.append(edCookieButtonsWrap);

    // Url
    const edCookieUrl = document.createElement('a');
    edCookieUrl.id = 'ed-cookiebanner-buttons-link';
    edCookieUrl.textContent = 'Zásady ochrany osobních údajů';
    edCookieUrl.href = '/ochrana-osobnich-udaju/';
    edCookieUrl.target = '_blank';
    edCookieWindow.append(edCookieUrl);

    document.body.append(edCookieWindow);
}

function createEDCookieMangeConsent() {
    const edCookieManager = document.createElement('div');
    edCookieManager.id = 'ed-cookiebanner-manage';
    edCookieManager.className = 'ed-cookiebanner-hidden';
    edCookieManager.textContent = 'Spravovat souhlas';

    document.body.append(edCookieManager);
}

function initEDCookieEvents() {
    const edCookieManager = document.getElementById('ed-cookiebanner-manage');
    const edCookieWindow = document.getElementById('ed-cookiebanner-window');
    if (edGetCookie(edCookieBannerShowWindowKey, '1') === '1') {
        edCookieWindow.classList.remove('ed-cookiebanner-hidden');
        edSetCookie(edCookieBannerShowWindowKey, '1');
    } else {
        edCookieManager.classList.remove('ed-cookiebanner-hidden');
        edSetCookie(edCookieBannerShowWindowKey, '0');
    }

    // Show cookie window
    edCookieManager.addEventListener('click', event => {
        edCookieManager.classList.add('ed-cookiebanner-hidden');
        edCookieWindow.classList.remove('ed-cookiebanner-hidden');
        edSetCookie(edCookieBannerShowWindowKey, '1');
    });

    // Show preferences
    const edShowPreferencesButton = document.getElementById('ed-cookiebanner-show-preferences-button');
    const edSavePreferencesButton = document.getElementById('ed-cookiebanner-save-preferences-button');
    const edPreferencesWrap = document.getElementsByClassName('ed-cookiebanner-preferences-wrap')[0];

    edShowPreferencesButton.addEventListener('click', event => {
        edShowPreferencesButton.classList.add('ed-cookiebanner-hidden');
        edSavePreferencesButton.classList.remove('ed-cookiebanner-hidden');
        edPreferencesWrap.classList.remove('ed-cookiebanner-hidden');
    });

    // Show/Hide accordion panel
    const edAccordionHeaderElements = document.getElementsByClassName('ed-cookiebanner-accordion-header');
    Array.from(edAccordionHeaderElements).forEach(element => {
        element.addEventListener('click', event => {
            if (event.target.classList.contains('ed-cookiebanner-switch-checkbox')) { return; }
            if (event.target.classList.contains('ed-cookiebanner-switch-slider')) { return; }
            
            if (event.target.classList.contains('ed-cookiebanner-accordion-close')) {
                event.target.classList.add('ed-cookiebanner-accordion-open');
                event.target.classList.remove('ed-cookiebanner-accordion-close');
                event.target.nextElementSibling.classList.remove('ed-cookiebanner-switch-panel-hidden');
            } else {
                event.target.classList.add('ed-cookiebanner-accordion-close');
                event.target.classList.remove('ed-cookiebanner-accordion-open');
                event.target.nextElementSibling.classList.add('ed-cookiebanner-switch-panel-hidden');
            }
        });
    });

    const edCookiePreferentialAccordionInput = document.getElementById('ed-cookiebanner-preferential-checkbox');
    const edCookieAnalyticAccordionInput = document.getElementById('ed-cookiebanner-analytic-checkbox');
    const edCookieMarketingAccordionInput = document.getElementById('ed-cookiebanner-marketing-checkbox');

    // Save all
    const edSaveAllButton = document.getElementById('ed-cookiebanner-save-all-button');
    edSaveAllButton.addEventListener('click', event => {
        edCookieManager.classList.remove('ed-cookiebanner-hidden');
        edCookieWindow.classList.add('ed-cookiebanner-hidden');
        edSetCookie(edCookieBannerShowWindowKey, '0');
        edSetCookie(edCookieBannerConsentFunctionalKey, '1'); // allways active
        edSetCookie(edCookieBannerConsentPreferentialKey, '1');
        edSetCookie(edCookieBannerConsentAnalyticKey, '1');
        edSetCookie(edCookieBannerConsentMarketingKey, '1');

        edUpdateConsent(
            '1', // marketingConsent
            '1', // analiticConsent
            '1' // preferenitalConsent
        );

        edShowPreferencesButton.classList.remove('ed-cookiebanner-hidden');
        edSavePreferencesButton.classList.add('ed-cookiebanner-hidden');
        edPreferencesWrap.classList.add('ed-cookiebanner-hidden');

        edCookiePreferentialAccordionInput.checked = true;
        edCookieAnalyticAccordionInput.checked = true;
        edCookieMarketingAccordionInput.checked = true;
    });
    // Reject
    const edRejectButton = document.getElementById('ed-cookiebanner-reject-button');
    edRejectButton.addEventListener('click', event => {
        edCookieManager.classList.remove('ed-cookiebanner-hidden');
        edCookieWindow.classList.add('ed-cookiebanner-hidden');
        edSetCookie(edCookieBannerShowWindowKey, '0');
        edSetCookie(edCookieBannerConsentFunctionalKey, '1'); // allways active
        edSetCookie(edCookieBannerConsentPreferentialKey, '0');
        edSetCookie(edCookieBannerConsentAnalyticKey, '0');
        edSetCookie(edCookieBannerConsentMarketingKey, '0');

        edUpdateConsent(
            '0', // marketingConsent
            '0', // analiticConsent
            '0' // preferenitalConsent
        );

        edShowPreferencesButton.classList.remove('ed-cookiebanner-hidden');
        edSavePreferencesButton.classList.add('ed-cookiebanner-hidden');
        edPreferencesWrap.classList.add('ed-cookiebanner-hidden');

        edCookiePreferentialAccordionInput.checked = false;
        edCookieAnalyticAccordionInput.checked = false;
        edCookieMarketingAccordionInput.checked = false;
    });
    // Save preferences
    edSavePreferencesButton.addEventListener('click', event => {
        edCookieManager.classList.remove('ed-cookiebanner-hidden');
        edCookieWindow.classList.add('ed-cookiebanner-hidden');

        edSetCookie(edCookieBannerShowWindowKey, '0');
        edSetCookie(edCookieBannerConsentFunctionalKey, '1'); // allways active
        edSetCookie(edCookieBannerConsentPreferentialKey, edCookiePreferentialAccordionInput.checked ? '1' : '0');
        edSetCookie(edCookieBannerConsentAnalyticKey, edCookieAnalyticAccordionInput.checked ? '1' : '0');
        edSetCookie(edCookieBannerConsentMarketingKey, edCookieMarketingAccordionInput.checked ? '1' : '0');

        
        edUpdateConsent(
            edCookieMarketingAccordionInput.checked ? '1' : '0', // marketingConsent
            edCookieAnalyticAccordionInput.checked ? '1' : '0', // analiticConsent
            edCookiePreferentialAccordionInput.checked ? '1' : '0' // preferenitalConsent
        );

        edShowPreferencesButton.classList.remove('ed-cookiebanner-hidden');
        edSavePreferencesButton.classList.add('ed-cookiebanner-hidden');
        edPreferencesWrap.classList.add('ed-cookiebanner-hidden');
    });

}

function edSetCookie(name, value) {
    let exDate = new Date();

    exDate.setDate(exDate.getDate()+365);
    let saveValue = value + '; expires=' + exDate.toUTCString();

    let domain = window.location.hostname;
    if (domain.length) {
        saveValue = saveValue + '; domain=.' + domain;
    }

    document.cookie = name + '=' + saveValue + '; path=/';
}

function edGetCookie(name, defaultValue = '') {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) { return match[2]; }

    return defaultValue;
}

function edUpdateConsent(marketingConsent, analiticConsent, preferenitalConsent) {
    gtag('consent', 'update', { 
        'ad_storage': marketingConsent === '1' ? 'granted' : 'denied',
        'ad_user_data': marketingConsent === '1' ? 'granted' : 'denied',
        'ad_personalization': marketingConsent === '1' ? 'granted' : 'denied',
        'analytics_storage': analiticConsent === '1' ? 'granted' : 'denied',
        'personalization_storage': preferenitalConsent === '1' ? 'granted' : 'denied'
    });
}
